"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.experimentPageNames = void 0;
const landingPageRegistry_1 = require("./landingPageRegistry");
// Experiment page names map descriptive keys to LandingPagePath enum values.
// When adding a new experiment page, also update experimentPagePaths in marketingPageDefinitions.ts.
// See the full checklist at: landingPageRegistry.ts (LandingPagePath enum header comment)
exports.experimentPageNames = {
    // UCC experiment pages (channel/campaign variants)
    LANDING_UCC: landingPageRegistry_1.LandingPagePath.LANDING_UCC,
    LANDING_DM_UCC: landingPageRegistry_1.LandingPagePath.LANDING_DM_UCC,
    LANDING_UCC_REWARDS: landingPageRegistry_1.LandingPagePath.LANDING_UCC_REWARDS,
    LANDING_UCC_REWARDS_EXPERIAN: landingPageRegistry_1.LandingPagePath.LANDING_UCC_REWARDS_EXPERIAN,
    LANDING_UCC_REWARDS_CK: landingPageRegistry_1.LandingPagePath.LANDING_UCC_REWARDS_CK,
    LANDING_DM_UCC_REWARDS: landingPageRegistry_1.LandingPagePath.LANDING_DM_UCC_REWARDS,
    LANDING_UCC_SEARCH: landingPageRegistry_1.LandingPagePath.LANDING_UCC_SEARCH,
    LANDING_PTA_UCC_REWARDS: landingPageRegistry_1.LandingPagePath.LANDING_PTA_UCC_REWARDS,
    LANDING_UCC_BT: landingPageRegistry_1.LandingPagePath.LANDING_UCC_BT,
    LANDING_UCC_BT_EXPERIAN: landingPageRegistry_1.LandingPagePath.LANDING_UCC_BT_EXPERIAN,
    LANDING_UCC_BT_CK: landingPageRegistry_1.LandingPagePath.LANDING_UCC_BT_CK,
    LANDING_DM_UCC_BT: landingPageRegistry_1.LandingPagePath.LANDING_DM_UCC_BT,
    LANDING_UCC_BALANCE_TRANSFER: landingPageRegistry_1.LandingPagePath.LANDING_UCC_BALANCE_TRANSFER,
    LANDING_UCC_ZERO_APR: landingPageRegistry_1.LandingPagePath.LANDING_UCC_ZERO_APR,
    LANDING_AVEN_CCBT: landingPageRegistry_1.LandingPagePath.LANDING_AVEN_CCBT,
    LANDING_HOA: landingPageRegistry_1.LandingPagePath.LANDING_HOA,
    LANDING_UCC_FLEX: landingPageRegistry_1.LandingPagePath.LANDING_UCC_FLEX,
    LANDING_UCC_FLEX_HOME_IMPROVEMENT: landingPageRegistry_1.LandingPagePath.LANDING_UCC_FLEX_HOME_IMPROVEMENT,
    LANDING_UCC_AVEN_FLEX: landingPageRegistry_1.LandingPagePath.LANDING_UCC_AVEN_FLEX,
    // Other campaign/experiment pages
    LANDING_CASHOUT_REFI: landingPageRegistry_1.LandingPagePath.LANDING_CASHOUT_REFI,
    FAVOR_AVEN: landingPageRegistry_1.LandingPagePath.FAVOR_AVEN,
    /** Entry point for the first-lien HELOC purchase prequalification flow (post-2026-July experiment) */
    LANDING_FLH_PURCHASE: landingPageRegistry_1.LandingPagePath.LANDING_FLH_PURCHASE,
    /** Entry point for first-lien HELOC refi on the generalized multi-lien framework */
    LANDING_FIRST_LIEN_HELOC_REFI: landingPageRegistry_1.LandingPagePath.LANDING_FIRST_LIEN_HELOC_REFI,
    // base names
    JOIN_AVEN: landingPageRegistry_1.LandingPagePath.JOIN_AVEN,
    AVEN_HELOC: landingPageRegistry_1.LandingPagePath.AVEN_HELOC,
    AVEN_CASH: landingPageRegistry_1.LandingPagePath.AVEN_CASH,
    AVEN_CASH_V2: landingPageRegistry_1.LandingPagePath.AVEN_CASH_V2,
    AVEN_CREDIT: landingPageRegistry_1.LandingPagePath.AVEN_CREDIT,
    AVEN_FLEX: landingPageRegistry_1.LandingPagePath.AVEN_FLEX,
    GO_AVEN: landingPageRegistry_1.LandingPagePath.GO_AVEN,
    GUARANTEE: landingPageRegistry_1.LandingPagePath.GUARANTEE,
    EXPLORE: landingPageRegistry_1.LandingPagePath.EXPLORE,
    TRY_AVEN: landingPageRegistry_1.LandingPagePath.TRY_AVEN,
    MEET_AVEN: landingPageRegistry_1.LandingPagePath.MEET_AVEN,
    VISIT_AVEN: landingPageRegistry_1.LandingPagePath.VISIT_AVEN,
    VIEW_AVEN: landingPageRegistry_1.LandingPagePath.VIEW_AVEN,
    TRANSFER_AVEN: landingPageRegistry_1.LandingPagePath.TRANSFER_AVEN,
    FIND_AVEN: landingPageRegistry_1.LandingPagePath.FIND_AVEN,
    AFFILIATE: landingPageRegistry_1.LandingPagePath.AFFILIATE,
    HLC_LANDING: landingPageRegistry_1.LandingPagePath.HLC_LANDING,
    DISCOVER_AVEN: landingPageRegistry_1.LandingPagePath.DISCOVER_AVEN,
    SALUTATIONS_AVEN: landingPageRegistry_1.LandingPagePath.SALUTATIONS_AVEN,
    AVEN_FINANCE: landingPageRegistry_1.LandingPagePath.AVEN_FINANCE,
    WITH_AVEN: landingPageRegistry_1.LandingPagePath.WITH_AVEN,
    USE_AVEN: landingPageRegistry_1.LandingPagePath.USE_AVEN,
    LIKE_AVEN: landingPageRegistry_1.LandingPagePath.LIKE_AVEN,
    AVEN_PAYCALC: landingPageRegistry_1.LandingPagePath.AVEN_PAYCALC,
    BANKRATE: landingPageRegistry_1.LandingPagePath.BANKRATE,
    DEBT: landingPageRegistry_1.LandingPagePath.DEBT,
    START: landingPageRegistry_1.LandingPagePath.START,
    ABTESTV1: landingPageRegistry_1.LandingPagePath.ABTESTV1,
    HOME_DEPOT: landingPageRegistry_1.LandingPagePath.HOME_DEPOT,
    HOME_IMPROVEMENT: landingPageRegistry_1.LandingPagePath.HOME_IMPROVEMENT,
    HOME_RENOVATION: landingPageRegistry_1.LandingPagePath.HOME_RENOVATION,
    REMODEL: landingPageRegistry_1.LandingPagePath.REMODEL,
    ILLUMINATING_DESIGN: landingPageRegistry_1.LandingPagePath.ILLUMINATING_DESIGN,
    EVOLUTION_SOLAR: landingPageRegistry_1.LandingPagePath.EVOLUTION_SOLAR,
    AERO_LIVING: landingPageRegistry_1.LandingPagePath.AERO_LIVING,
    IMPROVIFI: landingPageRegistry_1.LandingPagePath.IMPROVIFI,
    DBSPECIALISTS: landingPageRegistry_1.LandingPagePath.DBSPECIALISTS,
    TYPEFIVE: landingPageRegistry_1.LandingPagePath.TYPEFIVE,
    VICTORY: landingPageRegistry_1.LandingPagePath.VICTORY,
    GUARANTEED: landingPageRegistry_1.LandingPagePath.GUARANTEED, // for guaranteed lowest cost heloc (feb 2025)
    GUARANTEED_HELOC: landingPageRegistry_1.LandingPagePath.GUARANTEED_HELOC, // for guaranteed lowest cost heloc
    BEST_CC: landingPageRegistry_1.LandingPagePath.BEST_CC,
    YOUTUBE: landingPageRegistry_1.LandingPagePath.YOUTUBE,
    YELP: landingPageRegistry_1.LandingPagePath.YELP,
    LOVE: landingPageRegistry_1.LandingPagePath.LOVE,
    START_AVEN: landingPageRegistry_1.LandingPagePath.START_AVEN,
    AVEN_SAVING: landingPageRegistry_1.LandingPagePath.AVEN_SAVING,
    CHOOSE_AVEN: landingPageRegistry_1.LandingPagePath.CHOOSE_AVEN,
    LOWER_HELOC_PAYMENTS: landingPageRegistry_1.LandingPagePath.LOWER_HELOC_PAYMENTS,
    ENTER: landingPageRegistry_1.LandingPagePath.ENTER,
    /** DM LP for unlockaven.com */
    UNLOCK_AVEN: landingPageRegistry_1.LandingPagePath.UNLOCK_AVEN,
    /** LP for homeowners refinancing a car loan into an Aven HELOC */
    AUTO_REFI: landingPageRegistry_1.LandingPagePath.AUTO_REFI,
    // Path to drip other products to MOAP
    NEW_OFFER: landingPageRegistry_1.LandingPagePath.NEW_OFFER,
    // Used for mortgage cashback digital LP starting from 01/15/2024
    MORTGAGE_CASHBACK: landingPageRegistry_1.LandingPagePath.MORTGAGE_CASHBACK,
    // Used for mortgage cashback V2 digital LP starting from 03/28/2024
    MORTGAGE_CASHBACK_V2: landingPageRegistry_1.LandingPagePath.MORTGAGE_CASHBACK_V2,
    // Used for search app install campaign
    APP_OFFER: landingPageRegistry_1.LandingPagePath.APP_OFFER,
    TWENTY_TWENTY_FOUR: landingPageRegistry_1.LandingPagePath.TWENTY_TWENTY_FOUR,
    /** Landing page for leads from CreditKarma */
    KARMA: landingPageRegistry_1.LandingPagePath.KARMA,
    /** Another Landing page for CreditKarm */
    KARMA_V2: landingPageRegistry_1.LandingPagePath.KARMA_V2,
    /** Landing page for leads from Fund.com */
    FUND_AVEN: landingPageRegistry_1.LandingPagePath.FUND_AVEN,
    /** Landing page for leads from Experian */
    EXPERIAN: landingPageRegistry_1.LandingPagePath.EXPERIAN,
    /** Experian DM */
    EXPERIAN_INVITE: landingPageRegistry_1.LandingPagePath.EXPERIAN_INVITE,
    /** Simple Site A/B Test */
    CREDIT_CARD: landingPageRegistry_1.LandingPagePath.CREDIT_CARD,
    CREDIT_CARD_INVITE: landingPageRegistry_1.LandingPagePath.CREDIT_CARD_INVITE,
    /** Figure LP */
    FIGURE: landingPageRegistry_1.LandingPagePath.FIGURE,
    /** Rocket LP */
    ROCKET: landingPageRegistry_1.LandingPagePath.ROCKET,
    /** Credit Card Focused LP */
    HELOC_CARD: landingPageRegistry_1.LandingPagePath.HELOC_CARD,
    /** Personal Loan LP */
    PERSONAL_LOAN: landingPageRegistry_1.LandingPagePath.PERSONAL_LOAN,
    /** LP for Home Improvement Loan */
    HOME_IMPROVEMENT_LOAN: landingPageRegistry_1.LandingPagePath.HOME_IMPROVEMENT_LOAN,
    /** LP For Project Solar */
    PROJECT_SOLAR: landingPageRegistry_1.LandingPagePath.PROJECT_SOLAR,
    /** LP for Protection Guarantee */
    PROTECTION_GUARANTEE: landingPageRegistry_1.LandingPagePath.PROTECTION_GUARANTEE,
    /** LP for Guaranteed Lowest Rate */
    CARD_GUARANTEE: landingPageRegistry_1.LandingPagePath.CARD_GUARANTEE,
    /** LP for Guaranteed Lowest Cost HELOC */
    HELOC_GUARANTEE: landingPageRegistry_1.LandingPagePath.HELOC_GUARANTEE,
    /** LP for Guaranteed Lowest Rate HELOC */
    HELOC_RATE_GUARANTEE: landingPageRegistry_1.LandingPagePath.HELOC_RATE_GUARANTEE,
    /** LP for competitors findaven */
    FIND_AVEN_HELOC: landingPageRegistry_1.LandingPagePath.FIND_AVEN_HELOC,
    LENDING_TREE: landingPageRegistry_1.LandingPagePath.LENDING_TREE,
    /** LP for home equity loan */
    HELOAN: landingPageRegistry_1.LandingPagePath.HELOAN,
    AVEN_HE_LOAN: landingPageRegistry_1.LandingPagePath.AVEN_HE_LOAN,
    /** Direct-mail LP for the flanking brand creative */
    SPECIAL: landingPageRegistry_1.LandingPagePath.SPECIAL,
    /** LP for Avenamaze */
    AVENAMAZE: landingPageRegistry_1.LandingPagePath.AVENAMAZE,
    /* LP for Rocket launchpad */
    LAUNCH_PAD: landingPageRegistry_1.LandingPagePath.LAUNCH_PAD,
    LAUNCH_PAD_CASHOUT: landingPageRegistry_1.LandingPagePath.LAUNCH_PAD_CASHOUT,
    LAUNCH_PAD_CREDIT_CARD: landingPageRegistry_1.LandingPagePath.LAUNCH_PAD_CREDIT_CARD,
    LAUNCH_PAD_CASHOUT_INVITE: landingPageRegistry_1.LandingPagePath.LAUNCH_PAD_CASHOUT_INVITE,
    LAUNCH_PAD_CREDIT_CARD_INVITE: landingPageRegistry_1.LandingPagePath.LAUNCH_PAD_CREDIT_CARD_INVITE,
    LAUNCH_PAD_MAIL: landingPageRegistry_1.LandingPagePath.LAUNCH_PAD_MAIL,
    LAUNCH_PAD_MAIL_CASHOUT: landingPageRegistry_1.LandingPagePath.LAUNCH_PAD_MAIL_CASHOUT,
    LAUNCH_PAD_MAIL_CREDIT_CARD: landingPageRegistry_1.LandingPagePath.LAUNCH_PAD_MAIL_CREDIT_CARD,
    /* LP for CreditKarma */
    CREDIT_KARMA: landingPageRegistry_1.LandingPagePath.CREDIT_KARMA,
    CREDIT_KARMA_DISCLOSURES: landingPageRegistry_1.LandingPagePath.CREDIT_KARMA_DISCLOSURES,
    /* LP for Costco Free Executive Membership */
    COSTCO: landingPageRegistry_1.LandingPagePath.COSTCO,
    /* LP for Advisor Free Starbucks Promotion */
    ADVISOR_FREE_STARBUCKS: landingPageRegistry_1.LandingPagePath.ADVISOR_FREE_STARBUCKS,
    /* LP for Advisor Free Dunkin Promotion */
    ADVISOR_FREE_DUNKIN: landingPageRegistry_1.LandingPagePath.ADVISOR_FREE_DUNKIN,
    /* LP for Advisor Free Starbucks Promotion w HELOC policy */
    ADVISOR_FREE_STARBUCKS_HELOC: landingPageRegistry_1.LandingPagePath.ADVISOR_FREE_STARBUCKS_HELOC,
    /* LP for Advisor Free Dunkin Promotion w HELOC policy */
    ADVISOR_FREE_DUNKIN_HELOC: landingPageRegistry_1.LandingPagePath.ADVISOR_FREE_DUNKIN_HELOC,
    /* LP for Advisor Free Starbucks Promotion w dynamic policy */
    ADVISOR_FREE_STARBUCKS_INTENT_BASED_DYNAMIC: landingPageRegistry_1.LandingPagePath.ADVISOR_FREE_STARBUCKS_INTENT_BASED_DYNAMIC,
    /* LP for Advisor Free Dunkin Promotion w dynamic policy */
    ADVISOR_FREE_DUNKIN_INTENT_BASED_DYNAMIC: landingPageRegistry_1.LandingPagePath.ADVISOR_FREE_DUNKIN_INTENT_BASED_DYNAMIC,
    /* LP for 3% cash back up to 10k per year. based on CREDIT_CARD page */
    ANNUAL_THREE: landingPageRegistry_1.LandingPagePath.ANNUAL_THREE,
    /** LP for 7% Restaurants Promotion in Phoenix (serves as the fallback LP too if we don't know user's location) */
    RESTAURANTS_SEVEN: landingPageRegistry_1.LandingPagePath.RESTAURANTS_SEVEN,
    /** LP for 7% Restaurants Promotion in Ohio */
    RESTAURANTS_SEVEN_OHIO: landingPageRegistry_1.LandingPagePath.RESTAURANTS_SEVEN_OHIO,
    /** LP for Amazon Prime Promotion */
    AMAZON_PRIME: landingPageRegistry_1.LandingPagePath.AMAZON_PRIME,
    /** LP For G&G 7% Promotion */
    GAS_AND_GROCERIES_SEVEN: landingPageRegistry_1.LandingPagePath.GAS_AND_GROCERIES_SEVEN,
    /** LP for Sign Up Bonus */
    GET_AVEN: landingPageRegistry_1.LandingPagePath.GET_AVEN,
    /** LP for Flood Gate costco */
    FLOOD_COSTCO: landingPageRegistry_1.LandingPagePath.FLOOD_COSTCO,
    /** LP for Flood Gate home depot */
    FLOOD_HOME_DEPOT: landingPageRegistry_1.LandingPagePath.FLOOD_HOME_DEPOT,
    /** LP for Flood Gate 250 */
    FLOOD_250: landingPageRegistry_1.LandingPagePath.FLOOD_250,
    /** LP for 3% cash back on the first $100k */
    ANNUAL_THREE_100K: landingPageRegistry_1.LandingPagePath.ANNUAL_THREE_100K,
    ANNUAL_THREE_100K_INVITE: landingPageRegistry_1.LandingPagePath.ANNUAL_THREE_100K_INVITE,
    /** LP for 3% cash back up to 100k per year for Tampa residents */
    THREE_PERCENT_CB_ON_UP_TO_100K: landingPageRegistry_1.LandingPagePath.THREE_PERCENT_CB_ON_UP_TO_100K,
    /** LP for Bigger Pockets Promotion */
    BIGGER_POCKETS: landingPageRegistry_1.LandingPagePath.BIGGER_POCKETS,
    /** Marketing-text 0% fee campaign destinations */
    TEXT_MARKETING_ZERO_FEE_AVEN_CASH: landingPageRegistry_1.LandingPagePath.TEXT_MARKETING_ZERO_FEE_AVEN_CASH,
    TEXT_MARKETING_ZERO_FEE_MOAP: landingPageRegistry_1.LandingPagePath.TEXT_MARKETING_ZERO_FEE_MOAP,
    /** LP for PTA contribution */
    PTA_LANDING: landingPageRegistry_1.LandingPagePath.PTA_LANDING,
    PTA_DISCLOSURES: landingPageRegistry_1.LandingPagePath.PTA_DISCLOSURES,
    /** LP for Point of Sale Merchant bonus 5% cashback 20k limit + 200$ sign on bonus */
    POINT_OF_SALE_STORE_SPECIAL: landingPageRegistry_1.LandingPagePath.POINT_OF_SALE_STORE_SPECIAL,
    /** UCC Upgrade */
    HOME_UPGRADE: landingPageRegistry_1.LandingPagePath.HOME_UPGRADE,
    /** LP for real estate */
    REALTOR: landingPageRegistry_1.LandingPagePath.REALTOR,
    // Used for Hearth landing page
    HEARTH: landingPageRegistry_1.LandingPagePath.HEARTH,
    FOREST_RIVER: landingPageRegistry_1.LandingPagePath.FOREST_RIVER,
    FOREST_RIVER_DEALER: landingPageRegistry_1.LandingPagePath.FOREST_RIVER_DEALER,
    FOREST_RIVER_HOMELINE: landingPageRegistry_1.LandingPagePath.FOREST_RIVER_HOMELINE,
    FOREST_RIVER_JOURNEY: landingPageRegistry_1.LandingPagePath.FOREST_RIVER_JOURNEY,
    FOREST_RIVER_TRAILHEAD: landingPageRegistry_1.LandingPagePath.FOREST_RIVER_TRAILHEAD,
    CO_BRAND: landingPageRegistry_1.LandingPagePath.CO_BRAND,
    /** LP for Home Credit */
    HOME_CREDIT: landingPageRegistry_1.LandingPagePath.HOME_CREDIT,
    /** LP for Home Loan */
    HOME_LOAN: landingPageRegistry_1.LandingPagePath.HOME_LOAN,
    /** LP for Legion */
    LEGION: landingPageRegistry_1.LandingPagePath.LEGION,
    /** LP for Aven Legion */
    AVEN_LEGION: landingPageRegistry_1.LandingPagePath.AVEN_LEGION,
    /** LP for Aven Legion 10 */
    AVEN_LEGION_10: landingPageRegistry_1.LandingPagePath.AVEN_LEGION_10,
    /** LP for Lakeview */
    LAKEVIEW: landingPageRegistry_1.LandingPagePath.LAKEVIEW,
    /** LP for Del Amo Mall Booth */
    DEL_AMO_BOOTH: landingPageRegistry_1.LandingPagePath.DEL_AMO_BOOTH,
    AVEN_HOME_LOANS: landingPageRegistry_1.LandingPagePath.AVEN_HOME_LOANS,
    MAX_AVEN: landingPageRegistry_1.LandingPagePath.MAX_AVEN,
    APPLY_AVEN: landingPageRegistry_1.LandingPagePath.APPLY_AVEN,
    CLICK_AVEN: landingPageRegistry_1.LandingPagePath.CLICK_AVEN,
    AVEN_HELOCS: landingPageRegistry_1.LandingPagePath.AVEN_HELOCS,
    /** LP for Non-Bank HELOC campaign */
    NON_BANK_HELOC: landingPageRegistry_1.LandingPagePath.NON_BANK_HELOC,
    HELOC_GEO: landingPageRegistry_1.LandingPagePath.HELOC_GEO,
    HOA: landingPageRegistry_1.LandingPagePath.LANDING_HOA,
    /** LP for Aven MLO */
    AVEN_MLO: landingPageRegistry_1.LandingPagePath.AVEN_MLO,
    /** LP for Cashout Refinance */
    CASHOUT_REFINANCE: landingPageRegistry_1.LandingPagePath.CASHOUT_REFINANCE,
    /** LP for MultiLien Refinance */
    HOME_REFINANCE: landingPageRegistry_1.LandingPagePath.HOME_REFINANCE,
    /** DM LP for MultiLien Refinance with invite code */
    REFI_WITH_AVEN: landingPageRegistry_1.LandingPagePath.REFI_WITH_AVEN,
    /** LP for One Hour Refi */
    ONE_HOUR_REFI: landingPageRegistry_1.LandingPagePath.ONE_HOUR_REFI,
    /** LP for HOA Cashback */
    HOA_CASHBACK: landingPageRegistry_1.LandingPagePath.HOA_CASHBACK,
    // join names
    JOIN_AVEN_JOIN: landingPageRegistry_1.LandingPagePath.JOIN_AVEN_JOIN,
    AVEN_HELOC_JOIN: landingPageRegistry_1.LandingPagePath.AVEN_HELOC_JOIN,
    AVEN_CASH_JOIN: landingPageRegistry_1.LandingPagePath.AVEN_CASH_JOIN,
    AVEN_CASH_V2_JOIN: landingPageRegistry_1.LandingPagePath.AVEN_CASH_V2_JOIN,
    AVEN_CREDIT_JOIN: landingPageRegistry_1.LandingPagePath.AVEN_CREDIT_JOIN,
    GO_AVEN_JOIN: landingPageRegistry_1.LandingPagePath.GO_AVEN_JOIN,
    EXPLORE_JOIN: landingPageRegistry_1.LandingPagePath.EXPLORE_JOIN,
    TRY_AVEN_JOIN: landingPageRegistry_1.LandingPagePath.TRY_AVEN_JOIN,
    MEET_AVEN_JOIN: landingPageRegistry_1.LandingPagePath.MEET_AVEN_JOIN,
    VISIT_AVEN_JOIN: landingPageRegistry_1.LandingPagePath.VISIT_AVEN_JOIN,
    VIEW_AVEN_JOIN: landingPageRegistry_1.LandingPagePath.VIEW_AVEN_JOIN,
    TRANSFER_AVEN_JOIN: landingPageRegistry_1.LandingPagePath.TRANSFER_AVEN_JOIN,
    FIND_AVEN_JOIN: landingPageRegistry_1.LandingPagePath.FIND_AVEN_JOIN,
    DISCOVER_AVEN_JOIN: landingPageRegistry_1.LandingPagePath.DISCOVER_AVEN_JOIN,
    SALUTATIONS_AVEN_JOIN: landingPageRegistry_1.LandingPagePath.SALUTATIONS_AVEN_JOIN,
    AVEN_FINANCE_JOIN: landingPageRegistry_1.LandingPagePath.AVEN_FINANCE_JOIN,
    WITH_AVEN_JOIN: landingPageRegistry_1.LandingPagePath.WITH_AVEN_JOIN,
    BANKRATE_JOIN: landingPageRegistry_1.LandingPagePath.BANKRATE_JOIN,
    DEBT_JOIN: landingPageRegistry_1.LandingPagePath.DEBT_JOIN,
    START_JOIN: landingPageRegistry_1.LandingPagePath.START_JOIN,
    ABTESTV1_JOIN: landingPageRegistry_1.LandingPagePath.ABTESTV1_JOIN,
    ONE_YEAR_OF_STARBUCKS_PROMOTION: landingPageRegistry_1.LandingPagePath.ONE_YEAR_OF_STARBUCKS_PROMOTION,
    STARBUCKS_50_REWARDS: landingPageRegistry_1.LandingPagePath.STARBUCKS_50_REWARDS,
    STARBUCKS_50_HOME: landingPageRegistry_1.LandingPagePath.STARBUCKS_50_HOME,
    AVEN_CB: landingPageRegistry_1.LandingPagePath.AVEN_CB,
    FLEX_HOME_IMPROVEMENT: landingPageRegistry_1.LandingPagePath.LANDING_UCC_FLEX_HOME_IMPROVEMENT,
    CREATORS: landingPageRegistry_1.LandingPagePath.CREATORS,
    REWARDS_GROCERIES: landingPageRegistry_1.LandingPagePath.REWARDS_GROCERIES,
    REWARDS_GAS: landingPageRegistry_1.LandingPagePath.REWARDS_GAS,
    AVEN_GROCERIES: landingPageRegistry_1.LandingPagePath.AVEN_GROCERIES,
    AVEN_GAS_6: landingPageRegistry_1.LandingPagePath.AVEN_GAS_6,
    REWARDS_ZERO_APR_ON_1000_DOLLARS: landingPageRegistry_1.LandingPagePath.REWARDS_ZERO_APR_ON_1000_DOLLARS,
    REWARDS_FREE_STARBUCKS: landingPageRegistry_1.LandingPagePath.REWARDS_FREE_STARBUCKS,
    AVEN_FLEX_MAIL: landingPageRegistry_1.LandingPagePath.AVEN_FLEX_MAIL,
    AVEN_FLEX_NO_FEE_MAIL: landingPageRegistry_1.LandingPagePath.AVEN_FLEX_NO_FEE_MAIL,
    TRY_FLEX: landingPageRegistry_1.LandingPagePath.TRY_FLEX,
    AVEN_REWARDS_VISA_CARD: landingPageRegistry_1.LandingPagePath.AVEN_REWARDS_VISA_CARD,
    LANDING_REFER_REWARDS: landingPageRegistry_1.LandingPagePath.LANDING_REFER_REWARDS,
    CCB: landingPageRegistry_1.LandingPagePath.CCB,
    AVEN_SENIOR: landingPageRegistry_1.LandingPagePath.AVEN_SENIOR,
    AVEN_FAMILY: landingPageRegistry_1.LandingPagePath.AVEN_FAMILY,
    FIND_YOUR_AVEN: landingPageRegistry_1.LandingPagePath.FIND_YOUR_AVEN,
    BITCOIN_LOAN: landingPageRegistry_1.LandingPagePath.BITCOIN_LOAN,
    CRYPTO_REDIRECT: 'crypto', // Not in landingPageRegistry because this is just a redirect and doesn't require a policy config.
    BITCOIN_REDIRECT: 'bitcoin', // Not in landingPageRegistry because this is just a redirect and doesn't require a policy config.
};
